/**
 * Account permissions on routes.
 *
 * A route - or any parent of it - can declare the account permission a member needs to open it:
 *
 *   meta: { permission: ACCOUNT_PERMISSIONS.BILLING }
 *
 * Kept apart from router/index.js, which constructs the router and with it every view, so the rule
 * can be shared by the navigation guard and by anything that links to a route (the dashboard
 * banner) and be unit tested without any of that.
 *
 * @param {import('vue-router').Route} route A route object: `to` in a guard, or `router.resolve().route`
 * @param {(permission: string) => boolean} hasPermission The `auth/hasPermission` getter
 * @returns {boolean} Whether the member holds every permission the route declares
 */
export function isRouteAllowedByPermission(route, hasPermission) {
  return (route?.matched ?? []).every(record => {
    const permission = record.meta?.permission

    return !permission || hasPermission(permission)
  })
}
